__turbopack_context__.v({
  "className": "merriweather_77f5d99d-module__f8RyuG__className",
  "variable": "merriweather_77f5d99d-module__f8RyuG__variable",
});
